/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { removeProtocolPrefixFromUrl } from '../../../services/UrlService';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import { Link } from '../../Link/Link';

interface Props {
  meetingLink: string;
}

const messages = defineMessages({
  meetOnTheWeb: {
    id: 'firstJoinNative.selfHelp3',
  },
  openLinkInChrome: {
    id: 'firstJoinNative.selfHelp4',
  },
});

export const MeetOnTheWeb: React.FC<Props> = (props) => {
  const { meetingLink } = props;
  const { formatMessage: f } = useIntl();
  return (
    <Flex id='meetOnTheWeb' my={4}>
      <Text color='white'>
        {f(messages.meetOnTheWeb)}
        <br />
        {f(messages.openLinkInChrome)}
        <br />
        <Link textDecoration='underline' href={meetingLink}>
          {removeProtocolPrefixFromUrl(meetingLink)}
        </Link>
      </Text>
    </Flex>
  );
};
